import { normalizeVoicePhrase } from '@/lib/stt/dictation-commands';
const PERSONAL_KEYTERM_CAP = 25;
const MAX_WORDS = 4;
const MIN_LENGTH = 2;
const MAX_LENGTH = 48;
const BLOCKED_TERMS = new Set([
    'sign report',
    'sign the report',
    'submit',
    'scratch that',
    'new paragraph',
    'new line',
    'next field',
    'select that',
]);
function normalizeToken(value) {
    return value.trim().toLowerCase();
}
function normalizePersonalKeyterm(raw) {
    const trimmed = raw.trim().replace(/\s+/g, ' ');
    if (!trimmed)
        return null;
    return trimmed;
}
/**
 * @param extraBlockedPhrases Normalized (see normalizeVoicePhrase) command
 * phrases beyond the static built-ins - the user's custom voice bindings and
 * the active viewer bindings - so a spoken command is never learned as
 * vocabulary. Template section labels must NOT be passed here: they are
 * legitimate content words.
 */
export function isLearnableKeyterm(raw, extraBlockedPhrases) {
    const term = normalizePersonalKeyterm(raw);
    if (!term)
        return false;
    if (term.length < MIN_LENGTH || term.length > MAX_LENGTH)
        return false;
    if (term.includes('\n'))
        return false;
    if (BLOCKED_TERMS.has(term.toLowerCase()))
        return false;
    if (extraBlockedPhrases?.has(normalizeVoicePhrase(term)))
        return false;
    const words = term.split(/\s+/);
    if (words.length > MAX_WORDS)
        return false;
    return true;
}
export function mergePersonalKeyterms(existing, additions) {
    const ordered = [];
    const seen = new Set();
    // Existing terms keep priority: a learned addition never evicts a curated
    // term, it only appends into whatever capacity remains under the cap.
    for (const list of [existing, additions]) {
        for (const raw of list) {
            const term = normalizePersonalKeyterm(raw);
            if (!term || !isLearnableKeyterm(term))
                continue;
            const key = normalizeToken(term);
            if (seen.has(key))
                continue;
            seen.add(key);
            ordered.push(term);
            if (ordered.length >= PERSONAL_KEYTERM_CAP)
                return ordered;
        }
    }
    return ordered;
}
export { PERSONAL_KEYTERM_CAP };
